export enum PaymentGatewayType {
  payPal = 0,
  payPalBrainTree = 1,
  stripe = 2,
  payPalPayflow = 3,
  nic = 4,
  cyberSource = 5,
  velocity = 6,
  bbt = 7,
}
